import React, { useState, useEffect } from "react";
import { Table, Row, Button, Modal } from "antd";
import Icons from "assets/icons";
import {
  dataServiceTable,
  DataTableMenu,
} from "pages/Examination/components/InforDetail/DetailTabInfo/components/AssignList/components/ServiceTable/ServiceTable.config";
import { ColumnsType } from "antd/es/table";
import Icon from "@ant-design/icons";
import "pages/Examination/components/InforDetail/DetailTabInfo/components/AssignList/components/ServiceTable/ServiceTable.scss";
import { listExamination } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import examination, { setAction } from "redux/reducer/examination";
import { EXAMINATION_ACTION_TYPE } from "types/enums/examination";
import { setListAssign } from "redux/reducer/listAssign";
import SaveNewBCD from "./components/SaveNewBCD/SaveNewBCD";
import AskForAdd from "./components/AskForAdd/AskForAdd";
import {
  formatDateOrStringToStringGMT_7,
  formatDateToStringTimezone_7,
  formatToCurrencyType,
} from "helper/common";
import { Notification } from "components/common";
import dayjs from "dayjs";
import { FORMAT_TIME } from "types/enums";

const ServiceTable = () => {
  let dispatch = useAppDispatch();
  const action = useAppSelector((state) => state.examination);
  const listAssign = useAppSelector((state) => state.listAssign);
  // const
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);
  const [dataSource, setDataSource] =
    useState<Array<DataTableMenu>>(dataServiceTable);
  const [phieuCD, setPhieuCD] = useState<any>({});
  const [dsCD, setDsCD] = useState<any>([]);
  const [dataSourceAfterDelete, setDataSourceAfterDelete] =
    useState<Array<DataTableMenu>>(dataServiceTable);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openAsk, setOpenAsk] = useState<boolean>(false);
  const [askOk, setAskOk] = useState<any>(null);
  const [selectedServices, setSelectedServices] = useState<any>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
  const dataPhieu = useAppSelector((state) => state.examination.dataPhieu);
  const handleAskOk = () => {
    dispatch(setListAssign(askOk));
    setOpenAsk(false);
  };
  const handleAskCancel = () => {
    setOpenAsk(false);
  };
  const handleAdd = () => {
    let tmp = [...listAssign.dsChiDinh];
    selectedServices.map((it0) => {
      if (!!tmp.find((it1) => it1.id == it0.id)) {
        const soluong = tmp.find((tm) => tm.id == it0.id).soLuong;
        tmp = [
          ...tmp.filter((tm) => tm.id !== it0.id),
          { ...it0, soLuong: Number(soluong) + 1 },
        ];
      } else {
        tmp = [...tmp, it0];
      }
    });

    dispatch(setListAssign(tmp));
    setSelectedServices([]);
    setSelectedRowKeys([]);
    Notification("success", "Thêm thành công");
  };
  const handleDelete = (record) => {
    dispatch(
      setListAssign([
        ...listAssign.dsChiDinh.filter((it) => it.id != record.id),
      ])
    );
  };

  const handleSearch = (searchValue: string) => {
    const newDataSource = dataSourceAfterDelete.filter((record) =>
      columnsServiceTable.some((column) =>
        record[column.key as keyof DataTableMenu]
          ?.toString()
          ?.toLowerCase()
          ?.includes(searchValue.toLowerCase())
      )
    );
    setDataSource(newDataSource);
  };

  const columnsServiceTable: ColumnsType<DataTableMenu> = [
    {
      dataIndex: "stt",
      title: "STT",
      key: "stt",
      render: (v, r, idx) => <>{idx + 1}</>,
      align: "center",
    },
    {
      dataIndex: "tenDichVu",
      key: "tenDichVu",
      title: "Dịch vụ",
    },
    {
      dataIndex: "moTa",
      key: "moTa",
      title: "Mô tả",
    },
    {
      dataIndex: "donGia",
      key: "donGia",
      title: "Đơn giá BV",
      align: "right",
      render(value, record, index) {
        return <>{formatToCurrencyType(value)}</>;
      },
    },
    {
      dataIndex: "bhChiTra",
      key: "bhChiTra",
      title: "Đơn giá BHYT",
      align: "right",
      render(value, record, index) {
        return <>{formatToCurrencyType(value)}</>;
      },
    },
    {
      dataIndex: "canTuVan",
      key: "canTuVan",
      title: "Cần tư vấn",
      render: (v, r, idx) => {
        {
          if (v)
            return (
              <Row justify={"center"}>
                <Icon
                  style={{ color: "#45DC36" }}
                  component={
                    Icons.checkFilled as React.ForwardRefExoticComponent<any>
                  }
                />
              </Row>
            );
        }
      },
    },
  ];
  const getListDMDichVuKham = async () => {
    try {
      setLoading(true);
      let response = await listExamination.getListDMDichVuKham();
      setData(response.data.data);
      setLoading(false);
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };
  const fetchListByNDV = async (ndv) => {
    try {
      let response = await listExamination.getByIdNDV({
        idNhomDichVu: ndv.id,
      });
      if (response.status == 200) {
        setData(response.data);
      }
    } catch (error) {
      // notification.error({message: "Lấy danh sách dịch vụ không thành công"});
    }
  };

  const onSelectRow = (selectedRowKeys, selectedRows, info) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedServices(selectedRows);
  };
  const showModal = () => {
    if (listAssign.dsChiDinh.length > 0) setOpenModal(true);
    else {
      Notification("warning", "Chưa có chỉ định nào được chọn");
    }
  };
  useEffect(() => {
    getListDMDichVuKham();
  }, []);
  useEffect(() => {
    if (action.actionType == EXAMINATION_ACTION_TYPE.CLICKBCD) {
      setLoading(true);
      setData(action.dataPassing.dmDichVuDtos);
      setLoading(false);
    }
    if (action.actionType == EXAMINATION_ACTION_TYPE.CLICKNDV) {
      setLoading(true);
      fetchListByNDV(action.dataPassing);
      setLoading(false);
    }
    if (action.actionType == EXAMINATION_ACTION_TYPE.SEARCHDMDV) {
      setLoading(true);
      setData(action.dataPassing);
      setLoading(false);
    }
    if (action.actionType == EXAMINATION_ACTION_TYPE.DELETEBCD) {
      getListDMDichVuKham();
    }
  }, [action]);
  useEffect(() => {}, [data]);
  useEffect(() => {}, [selectedRowKeys]);
  const day = dayjs().format(FORMAT_TIME.timeDetail);
  const ngayTao = dayjs(dataPhieu?.ngayTao).format(FORMAT_TIME.timeDetail);
  const trangThaiKBNT = dataPhieu?.trangThai;
  const [disable, setDisable] = useState(false);
  useEffect(() => {
    const isDisabled =
      dayjs(ngayTao).isBefore(day, "day") && trangThaiKBNT === 3;
    setDisable(isDisabled);
  }, [day, ngayTao, trangThaiKBNT]);
  return (
    <Row gutter={[0, 8]} className="service-table-container">
      <Row justify="space-between" align={"middle"}>
        <Row justify={"space-between"}>
          <Button
            className="btn-sub"
            type="primary"
            onClick={handleAdd}
            icon={<Icons.add />}
            disabled={disable}
          >
            Thêm vào phiếu chỉ định
          </Button>
          <Button type="primary" onClick={showModal} icon={<Icons.file />}>
            Tạo bộ CĐ
          </Button>
        </Row>
        <Row>
          <SaveNewBCD {...{ open: openModal, setOpen: setOpenModal }} />
          <Modal
            title={"Số lượng là 1. Bạn thật sự muốn thêm?"}
            open={openAsk}
            onOk={handleAskOk}
            onCancel={handleAskCancel}
            closable={false}
          ></Modal>
        </Row>
      </Row>
      <Row>
        <Table
          rowKey={(record) => record.id}
          // pagination={{
          //   position: ["bottomRight"],
          //   showSizeChanger: false,
          // }}
          pagination={false}
          scroll={{ y: 240 }}
          columns={columnsServiceTable}
          dataSource={data ? data : []}
          loading={loading}
          bordered={true}
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectRow,
          }}
        />
      </Row>
    </Row>
  );
};

export default ServiceTable;
